import { useEffect } from "react";

import { getCachedItem, setCachedItem } from "../../helpers";
import { useGetUserList } from "../../hooks";

export const useUserHookFormList = ({ locationId } = {}) => {
  const cachedData = getCachedItem("users");
  const { data, isLoading, isSuccess } = useGetUserList({
    enabled: !cachedData,
  });
  const users = cachedData || data || [];

  useEffect(() => {
    if (data && isSuccess) {
      setCachedItem("users", data);
    }
  }, [data, isSuccess]);

  const usersFiltered = locationId
    ? users?.filter((u) => u.locationId === Number(locationId))
    : users;
  return { users: usersFiltered, isLoading, isSuccess };
};
